const upperCaseCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
const lowerCaseCharacters = "abcdefghijklmnopqrstuvwxyz"
const numericCharacters = "1234567890"
const specialCharacters = `-`

function validatePitstopShortName(pitstopShortName) {
    let pitstopShortNameArray=pitstopShortName.split("")
	return pitstopShortNameArray.every(v => (upperCaseCharacters.includes(v) || lowerCaseCharacters.includes(v) || numericCharacters.includes(v) || specialCharacters.includes(v)))
}

export default validatePitstopShortName
